import { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Row, Col, Button, Spinner } from "react-bootstrap";
import { Doughnut, Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Line } from 'react-chartjs-2'; // aggiungi Line
import { TimeScale } from 'chart.js';
import 'chartjs-adapter-date-fns';

import { Chart as ChartJS, ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, TimeScale, Tooltip, Legend, ChartDataLabels);

/*

PROPS: 
<CardRispondenti
//totalePartecipantiSondaggio={totalePartecipantiSondaggio}
partecipantiTotali={partecipantiTotali}
dataEtaPartecipante={dataEtaPartecipante}
datiGraficoTempo={datiGraficoTempo}
dataInizioSondaggio={dataInizioSondaggio}
dataFineSondaggio={dataFineSondaggio}
caricandoSondaggioERisposte={caricandoSondaggioERisposte}
            />
*/
export default function CardRispondenti(
  { 
    //totalePartecipantiSondaggio,
    //partecipantiTotali,
    dataEtaPartecipante,
    datiGraficoTempo,
    dataInizioSondaggio,
    dataFineSondaggio,
    caricandoSondaggioERisposte,
  tipoPunteggio,
datiPunteggiGrafico}) {


  useEffect(() => {
    console.log("datiPunteggiGrafico: ", datiPunteggiGrafico);
  }, [])


  const [tipoGraficoEta, setTipoGraficoEta] = useState('bar');

  //const percentualeRispondenti = (totalePartecipantiSondaggio / partecipantiTotali) * 100;

   // 1. Calcola la data minima (un giorno PRIMA di dataInizioSondaggio)
   let axisMinDate = null;
   if (dataInizioSondaggio) {
     try {
       const startDate = new Date(dataInizioSondaggio);
       // Verifica che la data sia valida prima di modificarla
       if (!isNaN(startDate.getTime())) {
         startDate.setDate(startDate.getDate() - 1); // Sottrai un giorno
         axisMinDate = startDate; // Chart.js accetta oggetti Date
       }
     } catch (e) {
       console.error("Errore nel parsing di dataInizioSondaggio:", dataInizioSondaggio, e);
       // Lascia axisMinDate a null se c'è un errore
     }
   }

   // 2. Calcola la data massima (un giorno DOPO l'ultima data in datiGraficoTempo.data)
  let axisMaxDate = null;
  if (datiGraficoTempo && datiGraficoTempo.data && datiGraficoTempo.data.length > 0) {
    try {
      // Trova l'ultima data presente nei dati (assumendo formato 'YYYY-MM-DD')
      // Usiamo reduce per sicurezza, anche se i dati dovrebbero essere ordinati
      const lastDataPointDateStr = datiGraficoTempo.data.reduce((latest, current) => {
        // Il confronto tra stringhe 'YYYY-MM-DD' funziona per trovare la più recente
        return current.x > latest ? current.x : latest;
      }, datiGraficoTempo.data[0].x); // Inizia con la prima data come confronto iniziale

      const lastDataDate = new Date(lastDataPointDateStr);
       // Verifica che la data sia valida
      if (!isNaN(lastDataDate.getTime())) {
        lastDataDate.setDate(lastDataDate.getDate() + 1); // Aggiungi un giorno
        axisMaxDate = lastDataDate;
      }
    } catch (e) {
      console.error("Errore nel processare l'ultima data dai dati:", datiGraficoTempo.data, e);
       // Lascia axisMaxDate a null se c'è un errore
    }
  }

   // Fallback per maxDate: se non ci sono dati di partecipazione o c'è stato un errore,
  // usa la data di fine sondaggio originale (o null se anch'essa non è valida)
  if (!axisMaxDate && dataFineSondaggio) {
    try {
       const fallbackEndDate = new Date(dataFineSondaggio);
       if (!isNaN(fallbackEndDate.getTime())) {
            axisMaxDate = fallbackEndDate; // Usa la data fine originale come limite massimo
       }
    } catch(e) {
       console.error("Errore nel parsing di dataFineSondaggio per fallback:", dataFineSondaggio, e);
    }
 }

  const toggleGrafico = () => {
    setTipoGraficoEta(prev => (prev === 'bar' ? 'doughnut' : 'bar'));
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: tipoGraficoEta === 'doughnut' ? 'right' : 'top',
        labels: {
          color: '#666',
          generateLabels: (chart) => {
            const { data } = chart;
            return data.labels.map((label, i) => ({
              text: label,
              fillStyle: data.datasets[0].backgroundColor[i],
              strokeStyle: data.datasets[0].backgroundColor[i],
              index: i
            }));
          }
        }
      },
      datalabels: {
        color: '#fff',
        font: {
          weight: 'bold',
          size: 14
        },
        formatter: (value, ctx) => {
          if (value === 0) {
            return null; // O return '';
          }
          const dataset = ctx.chart.data.datasets[0].data;
          const total = dataset.reduce((acc, val) => acc + val, 0);
          return total > 0 ? `${((value / total) * 100).toFixed(1)}%` : '0%';
        }
      }
    },
    scales: tipoGraficoEta === 'bar' ? {
      y: {
        beginAtZero: true,
        ticks: { stepSize: 1 },
        grid: { display: true }
      },
      x: {
        grid: { display: false },
        ticks: {
          display: true,
          autoSkip: false,
          maxRotation: 30,
          minRotation: 15,
          font: {
            size: 12
          }
        }
      }
    } : {}
  };


  const chartData = {
    labels: dataEtaPartecipante.labels,
    datasets: [
      {
        label: "Risposte",
        data: dataEtaPartecipante.datasets[0].data,
        backgroundColor: dataEtaPartecipante.datasets[0].backgroundColor,
        borderRadius: 8,
        barThickness: 40,
      }
    ]
  };



  const dataPartecipazioneNelTempo = {
    datasets: [
      {
        label: "Partecipazioni",
        data: datiGraficoTempo.data, // [{ x: '2025-01-10', y: 2 }, ...]
        fill: false,
        borderColor: '#0d6efd',
        backgroundColor: '#0d6efd',
        tension: 0.3,
        pointRadius: 5,
        pointHoverRadius: 6,
      }
    ]
  };
  const optionsPartecipazioneTempo = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: false // disattiva per questo grafico
      },
      legend: {
        display: true,
        position: 'top'
      },
      tooltip: {
        callbacks: {
          label: ctx => `${ctx.parsed.y} partecipant${ctx.parsed.y === 1 ? 'e' : 'i'}`
        }
      }
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'day',
          tooltipFormat: 'dd/MM/yyyy',
          displayFormats: {
            day: 'dd/MM/yyyy'
          }
        },
        min: axisMinDate,
        max: axisMaxDate,
        title: {
          display: true,
          text: 'Data'
        },
        ticks: {
          source: 'auto', //  mostra solo le date dei dati presenti
          autoSkip: true,
          maxRotation: 30,
          minRotation: 15
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Partecipanti'
        },
        ticks: {
          precision: 0
        }
      }
    }
  };

const labelsPunteggi = datiPunteggiGrafico?.data?.map(item => item.intPunDescrizione) ?? [];
const dataPunteggi = datiPunteggiGrafico?.data?.map(item => item.countPersoneConPunteggio) ?? [];


const datiGraficoPunteggi = {
  labels: datiPunteggiGrafico.labels,
  datasets: [
    {
      label: 'Persone',
      data: datiPunteggiGrafico.data,
      backgroundColor: ['#0d6efd', '#ffc107', '#28a745'],
      borderRadius: 8,
      barThickness: 40
    }
  ]
};


const opzioniGraficoPunteggi = {
  responsive: true,
  plugins: {
    legend: { display: false },
    datalabels: {
      color: '#fff',
      font: { weight: 'bold', size: 14 },
      formatter: (value) => value > 0 ? value : ''
    }
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: { stepSize: 1 },
      grid: { display: true }
    },
    x: {
      grid: { display: false },
      ticks: { font: { size: 12 } }
    }
  }
};


  return (
    <Row className="mt-4 gx-3">
      {/* Progress Card */}
      {tipoPunteggio && (
  <Col md={4}>
    <Card className='h-100 shadow-sm'>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-muted mb-0">Punteggi ottenuti</h6>
        </div>
        {caricandoSondaggioERisposte ? (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
            <Spinner animation="border" variant="primary" role="status" />
          </div>
        ) : (
          <div style={{ height: '200px' }}>
            <Bar data={datiGraficoPunteggi} options={opzioniGraficoPunteggi} plugins={[ChartDataLabels]} />
          </div>
        )}
      </Card.Body>
    </Card>
  </Col>
)}
      
      <Col md={tipoPunteggio? 4 : 8}>
        <Card className="h-100 shadow-sm">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="text-muted mb-0">Partecipazione al questionario</h6>
              
              </div>
            {/*<Card.Text>
              {totalePartecipantiSondaggio}  partecipanti hanno risposto.
            </Card.Text>
            <ProgressBar
              now={percentualeRispondenti}
              label={`${percentualeRispondenti.toFixed(1)}%`}
            />*/}
            {caricandoSondaggioERisposte ? (
              <>
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
                  <Spinner animation="border" variant="primary" role="status" />
                </div>
              </>
            ) : (
              <div style={{ height: '180px' }}>
                <Line data={dataPartecipazioneNelTempo} options={optionsPartecipazioneTempo} plugins={[]} />
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>


      {/* Fasce d'età - Grafico */}
      <Col md={4}>
        <Card className="h-100 shadow-sm">
          <Card.Body className="d-flex flex-column justify-content-between">
            {caricandoSondaggioERisposte ? (
              <>
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
                  <Spinner animation="border" variant="primary" role="status" />
                </div>
              </>
            ) : (<>
            {

            }
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="text-muted mb-0">Fasce d'età dei rispondenti</h6>
                <Button size="sm" variant="outline-primary" onClick={toggleGrafico}>
                  {tipoGraficoEta === 'bar' ? 'Visualizza torta' : 'Visualizza barre'}
                </Button>
              </div>
              <div style={{ width: tipoGraficoEta === 'bar' ? '100%' : '80%', maxWidth: tipoGraficoEta === 'bar' ? '100%' : '300px', margin: '0 auto' }}>
                {tipoGraficoEta === 'bar' ? (
                  <Bar data={chartData} options={chartOptions} plugins={[ChartDataLabels]} />
                ) : (
                  <Doughnut data={chartData} options={chartOptions} plugins={[ChartDataLabels]} />
                )}
              </div></>)
            }
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}
